import { actionTypes } from './constants';

export const secretPagesActionTypes = {
  setFetching: actionTypes.SECRET_PAGES_SET_FETCHING,
};
